import { memo } from 'react';
import { PopoverInfo, Switch, cn } from '@divlab/divanui';
import { IconInfoPopup } from '@divlab/divanui/icons';

import styles from './Switcher.module.css';

import type { FiltersFilterItem } from '@Types/Filters';
import type { HTMLAttributes } from 'react';
import type { Position } from '@divlab/divanui';

export interface SwitcherProps extends HTMLAttributes<HTMLDivElement> {
  name: string;
  item: FiltersFilterItem;
  className?: string;
  checked: boolean;
  notice?: string;
  disabled?: boolean;
  preferredPopupPositions?: Position[];
  onToggle?: () => void;
}

const Switcher = (props: SwitcherProps) => {
  const {
    name,
    item,
    notice,
    disabled,
    checked,
    preferredPopupPositions = ['bottom-left', 'left-bottom', 'right-bottom'],
    onToggle,
    ...restProps
  } = props;

  return (
    <div {...restProps} className={cn(styles.switchGroup, { [styles.disabled]: disabled })}>
      <Switch
        disabled={disabled}
        name={item.parameterId}
        checked={checked}
        onChange={onToggle}
        className={styles.switch}
      />
      <div className={styles.name}>{name}</div>

      {notice && (
        <PopoverInfo
          preferredPositions={preferredPopupPositions}
          slotTrigger={<IconInfoPopup className={styles.icon} />}
          className={styles.popoverInfo}
        >
          <div className={styles.popover}>{notice}</div>
        </PopoverInfo>
      )}
    </div>
  );
};

export default memo(Switcher);
